import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { numbersList } from "sources/books/trucks";
import components from "./components";

const config = {
    carId: {
        // async-select
        label: "Автомобиль",
        inputProps: { name: "carOption" },
        url: numbersList,
        propName: "number",
        validators: [requiredField],
        required: true,
        components: components.car,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
